// extracted by mini-css-extract-plugin
module.exports = {"LogoStyles":"Logo_LogoStyles__8YTVB","brandColor":"Logo_brandColor__3hLRn"};